import React from 'react';
import { IconButton } from '../../../CommonComponents/OPL/IconButton/IconButton';
import { useRefresh } from './useRefresh';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';

export const RefreshButton = () => {
  const { refresh, isRefreshing } = useRefresh();

  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <IconButton
      icon={isEmbeddedMobile ? 'far fa-sync' : 'fas fa-sync-alt'}
      size={isEmbeddedMobile ? 'medium' : 'small'}
      variant="subtleInactive"
      isLoading={isRefreshing}
      onClick={refresh}
      aria-label="Refresh"
    />
  );
};
